/**
 * activityService — connection-scoped activity feed (Phase D, social.invites_feed).
 *
 * The feed is DERIVED, not a content store: the server composes recent
 * connection events, presence transitions, and actionable invites, filtered by
 * the same block/invisible rules used everywhere else. No posts/stories.
 */

import { apiService } from './apiService';
import type { ActivityEntry } from '../../types/social';

const BASE = '/api/activity';

export async function getActivity(): Promise<ActivityEntry[]> {
  const res = await apiService.get<ActivityEntry[]>(BASE);
  if (res.error) throw new Error(res.error);
  return res.data ?? [];
}

export const activityService = {
  getActivity,
};

export default activityService;
